import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ExternalLinkIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M11.54 11.24L16.98 5.72H12.32V4.08H19.88V11.64H18.24V6.98L12.8 12.5L11.54 11.24ZM16.48 13.36H18.34V19.84H4.12V5.62H10.6V7.48H5.98V17.98H16.48V13.36Z" />
    </SvgIcon>
  );
});
